/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

const AdminFooter = ({ color, hasVibeCfo, ...props }) => {
  return (
    <>
      <Container fluid>
        <footer className="footer pt-0 bg-transparent">
          <Row className="align-items-center justify-content-lg-between ">
            <Col lg="12">
              <div className="copyright text-center text-lg-center text-muted">
                © {new Date().getFullYear()}{" "}
                <a
                  className="font-weight-bold ml-1"
                  href={hasVibeCfo ? "https://vibecfo.ai/" : "https://www.etani.ai/"}
                  target="_blank"
                  style={{ color: `${color}` }}
                >
                  {hasVibeCfo ? "Vibe CFO" : "Etani"}
                </a>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-lg-between ">
            <Col lg="12"><div className="copyright text-center text-lg-center text-muted">v2.5.0</div></Col>
          </Row>
        </footer>
      </Container>
    </>
  );
};

export default AdminFooter;
